document.getElementById("search-store").addEventListener("input", function () {
    const searchValue = this.value.trim();
    const stores = document.querySelectorAll("#our-stores .store-container");

    stores.forEach((store) => {
        const storePostcode = store.getAttribute("data-postcode");
        const postcodePrefix = storePostcode.substring(0, 2);

        if (
            searchValue === "" ||
            postcodePrefix.startsWith(searchValue.substring(0, 2))
        ) {
            store.classList.remove("hidden");
        } else {
            store.classList.add("hidden");
        }
    });
});
